module.exports = __webpack_public_path__ + "img/icon-org.a0fd0a5e.svg";